import * as React from "react";
import type { SVGProps } from "react";

/**
 * Star Icon - 星星/收藏图标
 * Used for: Favorites category
 */
const StarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={21}
    viewBox="0 0 48 48"
    {...props}
    fill={"currentColor"}
    fillRule={"evenodd"}
  >
    <path d="M24 4.7 29.346 18.1l14.854 1.4-11.2 9.8 3.5 14.4L24 35.9l-12.5 7.8 3.5-14.4-11.2-9.8 14.854-1.4z" />
  </svg>
);

export default StarIcon;

